import { render, staticRenderFns } from "./FactorAdjustmentModify.vue?vue&type=template&id=b6920faa&scoped=true&"
import script from "./FactorAdjustmentModify.vue?vue&type=script&lang=js&"
export * from "./FactorAdjustmentModify.vue?vue&type=script&lang=js&"
import style0 from "./FactorAdjustmentModify.vue?vue&type=style&index=0&id=b6920faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6920faa",
  null
  
)

export default component.exports